import { Route } from "react-router-dom";

interface RouteElement {
  path: string;
  el: JSX.Element;
}

interface RouteConfig extends RouteElement {
  layout?: boolean;
  children?: Array<RouteElement>;
}

const makeRoute = (route: RouteConfig) => {
  // If it's a route with children (like the PortalLayout route)
  if (route.children) {
    return (
      <Route path={route.path} key={route.path} element={route.el}>
        {route.children.map((child) => (
          <Route key={child.path} path={child.path} element={child.el} />
        ))}
      </Route>
    );
  }

  return <Route path={route.path} key={route.path} element={route.el} />;
};

export default makeRoute;
